var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.assassins)?_c('b-tag',{attrs:{"type":"is-danger"}},[_vm._v("Ass.")]):_c('b-tag',{attrs:{"type":"is-light"}},[_vm._v("Bers.")])}
var staticRenderFns = []

export { render, staticRenderFns }